import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import React from 'react'

export const STEPBAR_VARIANT_CRITICAL = 'critical'
export const STEPBAR_VARIANT_IMPROVABLE = 'improvable'
export const STEPBAR_VARIANT_INTERMEDIATE = 'intermediate'
export const STEPBAR_VARIANT_ADVANCED = 'advanced'
export const STEPBAR_VARIANT_OPTIMAL = 'optimal'

const UlStepsBar = styled.ul`
  display: flex;
`

const StepsBarEl = styled.li`
  width: 100%;
  height: 10px;
  background-color: #e2e2e2;

  width: 100%;
  position: relative;
  border-top-left-radius: ${props => (props.isFirst ? `10px` : '0')};
  border-bottom-left-radius: ${props => (props.isFirst ? `10px` : '0')};
  border-top-right-radius: ${props => (props.isLast ? `10px` : '0')};
  border-bottom-right-radius: ${props => (props.isLast ? `10px` : '0')};
  &:after {
    content: '';
    height: 4px;
    border-left: 2px solid #aaaa;
    position: absolute;
    top: -4px;
    opacity: ${props => (props.isFirst ? `0` : '1')};
  }
  &:before {
    content: '';
    height: 4px;
    border-left: ${props => (props.isFirst ? `0` : '2px solid #aaaa')};
    position: absolute;
    bottom: -4px;
  }
`
// stepsColor: ['#FA4747', '#FF9000', '#FFC400', '#8ACF61', '#39BA7C']

const handleVariant = ({ variant }) => {

  switch (variant) {
    case STEPBAR_VARIANT_CRITICAL:
      return 'background-color: #FA4747;'
    case STEPBAR_VARIANT_IMPROVABLE:
      return 'background-color:#FF9000;'
    case STEPBAR_VARIANT_INTERMEDIATE:
      return 'background-color: #FFC400;'
    case STEPBAR_VARIANT_ADVANCED:
      return 'background-color: #8ACF61;'
    case STEPBAR_VARIANT_OPTIMAL:
      return 'background-color: #39BA7C;'
  }
}

const StepsBarActive = styled.div`
  //background-color: ${props => `${props.colorActive}`};
  ${handleVariant};
  width: 100%;
  height: 10px;
  border-top-left-radius: ${props => (props.isFirst ? `10px` : '0')};
  border-bottom-left-radius: ${props => (props.isFirst ? `10px` : '0')};
  border-top-right-radius: ${props => (props.isLast ? `10px` : '0')};
  border-bottom-right-radius: ${props => (props.isLast ? `10px` : '0')};
`

export const StepsBar = ({ steps, value, variant, className }) => {
  const array = ['', '', '', '', '']
  return (
    <div className={className}>
      <UlStepsBar>
        {array.map((el, index) => (
          <StepsBarEl
            key={index}
            isFirst={index === 0}
            isLast={index === steps - 1}
          >
            {value > index && (
              <StepsBarActive
                isFirst={index === 0}
                isLast={index === value - 1}
                variant={variant}
                // colorActive={handleVariant(variant)}
              />
            )}
          </StepsBarEl>
        ))}
      </UlStepsBar>
    </div>
  )
}

StepsBar.propTypes = {
  steps: PropTypes.number,
  value: PropTypes.number,
  variant: PropTypes.string,
  className: PropTypes.string
}

StepsBar.defaultProps = {
  steps: 5,
  value: 3,
  variant: 'intermediate'
  // stepsColor: ['#FA4747', '#FF9000', '#FFC400', '#8ACF61', '#39BA7C']
}
